<template>
    <div>
        <!--<div class="nav">添加作业</div>-->
        <div class="newheight"></div>
        <div class="mychild">
            <a @click="clickTab(index)" :class="currentTab==index?'cur':''" v-for="(item,index) of child" :key="index">{{item.author}}</a>
        </div>


        <div class="addimg">
            <input type="file" id="upload" accept="image" @change="upload" style="display: none">
            <img :src="headerImage?headerImage:'img/addimg.png'" @click="checkImg">
        </div>

        <div class="f-but">
            <a href="javaScript:void(0)" @click="commit">提交作业</a>
        </div>

        <!--<div style="padding:20px;">-->
        <!--<div class="show">-->
        <!--<div class="picture" :style="'backgroundImage:url('+headerImage+')'"></div>-->
        <!--</div>-->
        <!--<div style="margin-top:20px;">-->
        <!--<input type="file" id="upload" accept="image" @change="upload" style="display: block">-->
        <!--<label for="upload"></label>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div @click="test">eeeeeeeeeeeeeeeeeeeee</div>-->
    </div>
</template>

<script>

    import axios from 'axios';
    import {Toast} from "mint-ui";

    export default {
        data() {
            return {
                headerImage: '',
                picValue: '',
                picUrl: '',
                uploadUrl: C.uploadUrl,
                imgprefix: C.imgprefix,
                userId: this.$route.query.userId,
                child: [],
                currentTab: 0,
                courseId:this.$route.query.courseId
            }
        },
        mounted() {
        },
        created() {
            this.getStudentList()
        },
        methods: {
            checkImg: function () {
                document.getElementById("upload").click();
            },
            upload(e) {
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length) return;
                this.picValue = files[0];
                let file = this.picValue;
                /* eslint-disable no-undef */
                let param = new FormData()  // 创建form对象
                param.append('file', file)  // 通过append向form对象添加数据
                param.append('chunk', '0') // 添加form表单中其他数据
                console.log(param.get('file')) // FormData私有类对象，访问不到，可以通过get判断值是否传进去
                let config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                }
                // 添加请求头
                axios.post(this.uploadUrl + 'upload/uploadImage', param, config)
                    .then(response => {
                        if (response.data.code === 10000) {
                            // self.ImgUrl = response.data.data
                            this.picUrl = response.data.result.fileName;
                            this.headerImage = this.imgprefix + response.data.result.fileName;
                        } else {
                            Toast('上传失败');
                            this.headerImage = '';
                            this.picUrl = '';
                        }

                    })

                //this.imgPreview(this.picValue);
            },
            //查询学生列表
            getStudentList: function () {
                R.Course.getStudent({
                    userId: this.userId
                }).then(result => {
                    this.child = result
                })
            },
            // 切换页面
            clickTab: function (index) {
                this.currentTab = index
            },
            //提交
            commit: function () {
                if (!this.picUrl) {
                    Toast('上传失败');
                    return;
                }
                let studentId = this.child[this.currentTab].studentId;
                let author = this.child[this.currentTab].author;
                if (!studentId) {
                    Toast('请选择学生');
                    return;
                }
                let info={userId: this.userId,studentId:studentId,type:'4',
                    courseId:this.courseId,openFlag:'0',author}
                let pics = [{
                    pic: this.picUrl,
                    sort: 0,
                    thumbnail: this.picUrl
                }]
                info.pic=JSON.stringify(pics);
                R.Course.saveRead(info).then(() => {
                    history.back(0);
                })

            }
        }
    }
</script>

<style>

    html, body {
        background: #fff;
        height: 100%
    }

    .course-video video, .videoBox {
        height: 211px;
        width: 100%;
    }

    .videoTitle { /* height: 152px; */
        font-size: 17px;
        color: #000;
    }

    .videoTitle .videoTitle-t {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        height: 37px;
        background-color: #f1f1f1;
    }

    .videoTitle-t-one img {
        width: 16px;
        height: 16px;
        vertical-align: -3px;
    }

    .videoTitle-t-one i {
        display: inline-block;
        width: 1px;
        height: 16px;
        background: #cacaca;
        position: relative;
        top: 3px;
    }

    .videoTitle-t-one img.share {
        padding-left: 0;
        border-right: none;
    }

    .videoTitle-b {
        padding: 0 15px;
    }

    .videoTitle-b text {
        font-weight: bold;
        display: block;
        font-size: 17px;
        color: #000;
        padding: 20px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .njtab {
        border-top: 10px solid #ebecea;
        height: 51px;
        line-height: 42px;
        font-size: 15px;
        color: #000;
        padding: 0 10px;
        display: flex;
        justify-content: space-around;
        border-bottom: 1px solid #edeeec;
    }

    .njtab-div {
        width: calc((100% - 30px) / 4);
        height: 100%;
        margin-right: 10px;
        display: inline-block;
        text-align: center;
    }

    .njtab-div:last-child {
        margin-right: 0;
    }

    .njtab-div.active {
        color: #32a658;
        height: 40px;
        border-bottom: 2px solid #32a658;
    }

    .nav {
        height: 48px;
        padding-top: 20px;
        width: 100%;
        position: fixed;
        top: 0;
        text-align: center;
        display: flex;
        flex-direction: row;
        z-index: 9999;
        background: #F8F8F8;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        line-height: 24px;
        margin: 0;
        padding: 0;
        font-weight: 600;
    }

    .show {
        padding: 12px;
    }

    .task-list {
        border-bottom: 1px solid #e4e4e4;
        padding-bottom: 15px;
        margin-bottom: 16px;
    }

    .task-img {
        border-radius: 6px;
        overflow: hidden
    }

    .task-list img {
        width: 100%;
        border-radius: 6px;
    }

    .task-name {
        height: 45px;
        line-height: 45px;
    }

    .task-name span {
        width: 24px;
        height: 24px;
        border-radius: 100px;
        overflow: hidden
    }

    .task-name span img {
        display: inline-block;
        width: 24px;
        height: 24px;
        border-radius: 100px;
        position: relative;
        top: 5px;
    }

    .task-name b {
        font-size: 14px;
        color: #000;
        font-weight: normal;
    }

    .task-name em {
        float: right;
        font-size: 12px;
        color: #666666;
    }

    .task-fun {
        height: 25px;
    }

    .task-fun {
    }

    .foleft {
        float: left;
    }

    .foright {
        float: right
    }

    .task-fun span.foright span {
        display: inline-block;
        height: 25px;
        font-size: 14px;
        color: #000000;
    }

    .task-fun span.foleft span {
        display: inline-block;
        height: 25px;
        font-size: 14px;
        color: #000000;
        margin-right: 19px
    }

    .task-fun span img {
        width: 23px;
        position: relative;
        top: 4px;
    }

    .mychild {
        padding: 15px;
    }

    .newheight {
        height: 48px;
    }

    .mychild a {
        display: inline-block;
        height: 32px;
        line-height: 30px;
        font-size: 15px;
        color: #666666;
        padding: 0 18px;
        border: 1px solid #c9c8c8;
        border-radius: 100px;
        margin-right: 5px;
    }

    .mychild a.cur {
        background: #32a658;
        color: #ffffff;
        border: 1px solid #32a658
    }

    .addimg {
        padding: 0 16px;
        margin-top: 5px;
    }

    .addimg img {
        width: 100%;
    }

    .f-but {
        position: fixed;
        left: 0;
        right: 0;
        margin: 0 auto;
        bottom: 32px;
        width: 210px;
        height: 39px;
        border-radius: 100px;
        background: #32a658;
    }

    .f-but a {
        display: block;
        width: 100%;
        height: 39px;
        border-radius: 100px;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
        line-height: 39px;
    }
</style>
